export const BUDGET_CAP = 2000;

export const LOGO_PRIMARY =
  "https://customer-assets.emergentagent.com/wingman/ba2a63f5-7787-425f-ac3e-3ba1fbdcb661/attachments/91d7831487e74a27af6fc7819b79e8a0_Main Logo 2.jpg";

export const LOGO_SECONDARY =
  "https://customer-assets.emergentagent.com/wingman/ba2a63f5-7787-425f-ac3e-3ba1fbdcb661/attachments/855d75ab7d3345a5a195fb2e1f7c3a9a_Screenshot_20260502_234655_Canva.jpg";

// Image mapping by service id (chosen to visually match each garden item)
export const SERVICE_IMAGES = {
  "jet-wash":
    "https://images.unsplash.com/photo-1719324923413-ba0a066465c9?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "tidy-up":
    "https://images.unsplash.com/photo-1622383563227-04401ab4e5ea?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "hedge-cutting":
    "https://images.unsplash.com/photo-1668120089662-42642838cfef?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "flower-beds":
    "https://images.unsplash.com/photo-1622383563227-04401ab4e5ea?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "raised-planter":
    "https://images.unsplash.com/photo-1591857177580-dc82b9ac4e1e?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "small-returfing":
    "https://images.unsplash.com/photo-1668120089662-42642838cfef?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "decorative-gravel":
    "https://images.unsplash.com/photo-1599598425947-5b3f0a32edd0?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "garden-lighting":
    "https://images.unsplash.com/photo-1758450399245-0e1c5d4c2536?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "new-path":
    "https://images.unsplash.com/photo-1761637823293-f96835ec5038?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "fence-repair":
    "https://images.unsplash.com/photo-1568048689711-5e0325cea8c1?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "timber-decking":
    "https://images.unsplash.com/photo-1591857177580-dc82b9ac4e1e?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  pergola:
    "https://images.unsplash.com/photo-1758450399245-0e1c5d4c2536?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "patio-seating":
    "https://images.unsplash.com/photo-1719324923413-ba0a066465c9?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "decking-bbq":
    "https://images.unsplash.com/photo-1591857177580-dc82b9ac4e1e?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "artificial-grass":
    "https://images.unsplash.com/photo-1668120089662-42642838cfef?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "fire-pit":
    "https://images.unsplash.com/photo-1758450399245-0e1c5d4c2536?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "slabbed-patio":
    "https://images.unsplash.com/photo-1761637823293-f96835ec5038?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
};

export const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1761637823293-f96835ec5038?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "https://images.unsplash.com/photo-1668120089662-42642838cfef?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "https://images.unsplash.com/photo-1758450399245-0e1c5d4c2536?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
  "https://images.unsplash.com/photo-1719324923413-ba0a066465c9?crop=entropy&cs=srgb&fm=jpg&q=80&w=900",
];

export const AYRSHIRE_TOWNS = [
  "Ayr",
  "Kilmarnock",
  "Irvine",
  "Troon",
  "Prestwick",
  "Saltcoats",
  "Stevenston",
  "Ardrossan",
  "Largs",
  "Cumnock",
  "Mauchline",
  "Kilwinning",
  "Stewarton",
  "Beith",
  "Dalry",
  "West Kilbride",
  "Maybole",
  "Girvan",
  "Tarbolton",
  "Dalmellington",
  "Other (Ayrshire)",
];
